(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savanna-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const galleryButton = event.target.closest('[data-savanna-gallery-button]');
    if (galleryButton) {
      const productSection = galleryButton.closest('[data-savanna-product]');
      const selectedImage = galleryButton.dataset.savannaGalleryButton;
      productSection.querySelectorAll('[data-savanna-gallery-image]').forEach((image) => {
        image.hidden = image.dataset.savannaGalleryImage !== selectedImage;
      });
      productSection.querySelectorAll('[data-savanna-gallery-button]').forEach((button) => {
        const isActive = button === galleryButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      return;
    }

    const stickyButton = event.target.closest('[data-savanna-sticky-add]');
    if (stickyButton) {
      const productSection = stickyButton.closest('[data-savanna-product]');
      productSection.querySelector('[data-savanna-main-add]').click();
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-savanna-variant]')) return;
    const productSection = event.target.closest('[data-savanna-product]');
    const price = event.target.dataset.price;
    productSection.querySelectorAll('[data-savanna-price], [data-savanna-button-price]').forEach((priceElement) => {
      priceElement.textContent = price;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savanna-shop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-savanna-sort]')) event.target.form.submit();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-savanna-view]');
    if (!button) return;
    const shop = button.closest('.savanna-shop');
    const grid = shop.querySelector('[data-savanna-grid]');
    const listView = button.dataset.savannaView === 'list';
    grid.classList.toggle('is-list', listView);
    shop.querySelectorAll('[data-savanna-view]').forEach((item) => item.classList.toggle('is-active', item === button));
  });

  } catch(e) { console.error(e); }
})();
})();
